module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alignment",
    attrs: {
      "id": "ALIGN-SWF"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Align_container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "左对齐",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[0].active, disabled: _vm.items[0].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(0)
      }
    }
  }, [(_vm.items[0].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_AlignLeft_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[0].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_AlignLeft_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "水平居中对齐",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[1].active, disabled: _vm.items[1].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(1)
      }
    }
  }, [(_vm.items[1].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_AlignCenter_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[1].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_AlignCenter_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "右对齐",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[2].active, disabled: _vm.items[2].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(2)
      }
    }
  }, [(_vm.items[2].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_AlignRight_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[2].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_AlignRight_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "水平等距",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[3].active, disabled: _vm.items[3].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(3)
      }
    }
  }, [(_vm.items[3].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_AlignJustify_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[3].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_AlignJustify_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "顶对齐",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[4].active, disabled: _vm.items[4].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(4)
      }
    }
  }, [(_vm.items[4].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ValighTop_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[4].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ValighTop_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "垂直居中对齐",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[5].active, disabled: _vm.items[5].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(5)
      }
    }
  }, [(_vm.items[5].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ValignMiddle_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[5].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ValignMiddle_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "底对齐",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[6].active, disabled: _vm.items[6].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(6)
      }
    }
  }, [(_vm.items[6].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ValighBottom_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[6].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ValighBottom_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "垂直等距",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[7].active, disabled: _vm.items[7].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(7)
      }
    }
  }, [(_vm.items[7].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ValighJustify_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[7].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ValighJustify_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "最近对齐",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[8].active, disabled: _vm.items[8].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(8)
      }
    }
  }, [(_vm.items[8].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ZalighUp_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[8].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ZalighUp_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "最远对齐",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[9].active, disabled: _vm.items[9].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(9)
      }
    }
  }, [(_vm.items[9].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ZalighDown_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[9].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_ZalighDown_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "Width_container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "水平最短",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[10].active, disabled: _vm.items[10].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(10)
      }
    }
  }, [(_vm.items[10].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_WidthMin_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[10].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_WidthMin_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "水平最长",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[11].active, disabled: _vm.items[11].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(11)
      }
    }
  }, [(_vm.items[11].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_WidthMax_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[11].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_WidthMax_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "垂直最短",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[12].active, disabled: _vm.items[12].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(12)
      }
    }
  }, [(_vm.items[12].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_HeightMin_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[12].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_HeightMin_normal.png")
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "垂直最长",
      "placement": "bottom"
    }
  }, [_c('div', {
    class: {
      active: _vm.items[13].active, disabled: _vm.items[13].disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleAliginItemClick(13)
      }
    }
  }, [(_vm.items[13].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_HeightMax_disabled.png")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.items[13].disabled) ? _c('div', [_c('img', {
    attrs: {
      "src": require("./layout_HeightMax_normal.png")
    }
  })]) : _vm._e()])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align"
  }, [_c('p', [_vm._v("对齐布局")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width"
  }, [_c('p', [_vm._v("统一大小")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-309a61ae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Align/Align.vue
// module id = 378
// module chunks = 0